import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface OrganizationTasksDialogProps {
    open: boolean;
}

const initialState: OrganizationTasksDialogProps = { open: false };

const organizationTasksDialogSlice = createSlice({
    name: 'organizationTasksDialog',
    initialState,
    reducers: {
        openOrganizationTasksDialog: (state) => {
            state.open = true;
            return state;
        },
        closeOrganizationTasksDialog: (state) => {
            state = initialState;
            return state;
        },
    },
});

export const { openOrganizationTasksDialog, closeOrganizationTasksDialog, } = organizationTasksDialogSlice.actions;
export default organizationTasksDialogSlice.reducer;
export const selectOrganizationTasksDialog = (state: RootState) => state.organizationTasksDialog;